import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import { removeMirroredProducts } from 'rangeConfig/knoxhult/filters/mainMenuProductFilters';
import { cabinetsSelected } from 'rangeConfig/knoxhult/rules/selectedRules';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';

const cabinetsProductListConfig: ProductListConfig = {
  cardsTitle: '',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.productListCabinetsTitle',
  mobileCardText: 'communicatedSizeText',
  productFilters: [removeMirroredProducts],
  cluster: [],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  sortOrder: [],
  selected: cabinetsSelected,
  categories: [
    {
      id: 'base-cabinets',
      products: [
        { path: 'type', value: ProductType.KNOXHULT_CABINET_ASM },
        { path: 'type', value: ProductType.KNOXHULT_SINK_CABINET_ASM },
        { path: 'type', value: ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM },
        { path: 'type', value: ProductType.KNOXHULT_CORNER_CABINET_ASM },
        { path: 'type', value: ProductType.KNOXHULT_NICHE_CABINET_ASM }
      ]
    },
    {
      id: 'wall-cabinets',
      products: [
        { path: 'type', value: ProductType.KNOXHULT_WALL_CABINET_ASM },
        { path: 'type', value: ProductType.KNOXHULT_WALL_GLASS_CABINET_ASM }
      ]
    },
    {
      id: 'high-cabinets',
      products: [{ path: 'type', value: ProductType.KNOXHULT_HIGH_CABINET_ASM }]
    },
    {
      id: 'open-frames',
      products: [{ path: 'type', value: ProductType.ENHET_WALL_FRAME }]
    }
  ]
};

export default cabinetsProductListConfig;
